// react-markdown without remark-gfm cannot render tables, and Jira descriptions use both
// Jira wiki tables (`||Head||Head||` / `|cell|cell|`) and Markdown pipe tables. This pulls
// table blocks out of the text so the rest can go through react-markdown unchanged.

const ROW_RE = /^\s*\|.*\|\s*$/;
const SEPARATOR_RE = /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/;

function splitCells(line) {
  return line
    .trim()
    .replace(/^\|\|?/, '')
    .replace(/\|\|?$/, '')
    .split(/\|\|?/)
    .map((cell) => cell.trim());
}

function parseTable(lines) {
  const hasSeparator = lines.length > 1 && SEPARATOR_RE.test(lines[1]);
  const rows = lines
    .filter((_, i) => !(hasSeparator && i === 1))
    .map((line, i) => ({
      header: line.trim().startsWith('||') || (hasSeparator && i === 0),
      cells: splitCells(line),
    }));
  return { type: 'table', rows };
}

// Returns [{ type: 'text', text } | { type: 'table', rows: [{ header, cells[] }] }]
export function splitTables(input) {
  const lines = String(input ?? '').split('\n');
  const segments = [];
  let text = [];
  const flushText = () => {
    if (text.length) segments.push({ type: 'text', text: text.join('\n') });
    text = [];
  };

  for (let i = 0; i < lines.length; i++) {
    if (!ROW_RE.test(lines[i])) {
      text.push(lines[i]);
      continue;
    }
    const block = [];
    while (i < lines.length && ROW_RE.test(lines[i])) block.push(lines[i++]);
    i--;
    flushText();
    segments.push(parseTable(block));
  }
  flushText();
  return segments;
}
